import { Grid, Typography, Box } from '@material-ui/core';

const IntroPricingDisplay = (props) => {
  const { classes, orderItem, totalText } = props;
  const introPricing = orderItem?.introPricing;

  return (
    <Grid item container className={classes.itemContainer}>
      <Grid item className="total-text" xs={12} sm={6}>
        <Typography>{totalText}</Typography>
      </Grid>
      <Grid item className="total-value" xs={12} sm={6}>
        <Typography className={classes.introPriceLogo} component={Box}>
          {introPricing?.introPricingLabel}
        </Typography>

        {introPricing?.prefixCurrencySymbol && (
          <Typography
            display="inline"
            className={classes.introPriceCurrencySymbol}
          >
            {introPricing?.discountPriceLineCurrencySymbol}
          </Typography>
        )}
        <Typography display="inline" className={classes.introPriceTotalAmount}>
          {introPricing?.discountPrice}
        </Typography>
        {!introPricing?.prefixCurrencySymbol && (
          <Typography
            display="inline"
            className={classes.introPriceCurrencySymbol}
          >
            {introPricing?.discountPriceLineCurrencySymbol}
          </Typography>
        )}
        <Typography
          display="inline"
          className={classes.introPriceDiscountLength}
        >
          {introPricing?.discountPricePeriod}
        </Typography>
        <Box className={classes.introPriceLine}></Box>
        <Typography
          display="inline"
          className={classes.introPriceAfterDiscountPrefix}
        >
          {introPricing?.afterDiscountPrefix}
        </Typography>
        {introPricing?.prefixCurrencySymbol && (
          <Typography
            display="inline"
            className={classes.introPriceAfterDiscountPrice}
          >
            {introPricing?.discountPriceLineCurrencySymbol}
          </Typography>
        )}
        <Typography
          display="inline"
          className={classes.introPriceAfterDiscountPrice}
        >
          {introPricing?.afterDiscountPrice}
        </Typography>
        {!introPricing?.prefixCurrencySymbol && (
          <Typography
            display="inline"
            className={classes.introPriceAfterDiscountPrice}
          >
            {introPricing?.discountPriceLineCurrencySymbol}
          </Typography>
        )}
        <Typography
          display="inline"
          className={classes.introPriceAfterDiscountSuffix}
        >
          {introPricing?.afterDiscountSuffix}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default IntroPricingDisplay;
